import { render } from "./hr-document-module-info.vue?vue&type=template&id=9332aa20&scoped=true"
import script from "./hr-document-module-info.vue?vue&type=script&lang=js"
export * from "./hr-document-module-info.vue?vue&type=script&lang=js"

import "./hr-document-module-info.vue?vue&type=style&index=0&id=9332aa20&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9332aa20"]])

export default __exports__